import {
    Box,
    List,
    ListItem,
    makeStyles,
    Paper,
    Grid,
    Theme,
    Typography,
} from '@material-ui/core';
import axios from 'axios';
import clsx from 'clsx';
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import {
    member as v_member,
    basic,
    Values,
    member,
    order as v_order,
    order,
    SNACKBAR_TIME,
} from '../request/values';
import { TitleBackBar } from './header/TitleBar';
import { COLORS } from './Theme';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    questItem: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',

        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        [theme.breakpoints.up('md')]: {
            width: '98%',
        },
    },
    questItemComplete: {
        borderRadius: 12,
        margin: 'auto',
        marginBottom: '1.5vh',

        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        width: '82vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
        backgroundColor: 'lightgray',
        [theme.breakpoints.up('md')]: {
            width: '98%',
        },
    },
    list: {
        width: '86vw',
        height: '74.5vh',
        overflowY: 'auto',
        ...theme.typography.subtitle1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up('md')]: {
            width: '62vw',
            height: '100%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(6),
        },
    },
    questDesc: {
        paddingLeft: '1vw',
        '& #materialSubName': {
            ...theme.typography.body1,
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    questComplete: {
        color: `${COLORS.WATER_BLUE}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    questNone: {
        color: `${COLORS.DOWN}`,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },

    questList: {
        width: '100%',
        maxWidth: 360,
    },
    questSheet: {
        // height : 'calc(100%- 64px)',
        // top: 64
        height: '100vh',
    },
    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            marginBottom: '2.5vh',
            opacity: 0.4,
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    sideText: {
        ...theme.typography.h1,
        fontFamily: 'NanumR',
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h5,
            fontFamily: 'NanumR',
            fontWeight: 'normal',
        },
    },
}));

interface iQuestList {
    quest_num: number;
    quest_money: number;
    require_num: number;
}

const QuestList: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { member } = props;

    const [quest, setQuest] = useState<iQuestList[]>([]);
    const [completeNum, setCompleteNum] = useState(0);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const getCompleteNum = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.complete_num
        );
        let params = { companyNum: member.companyNum };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    setCompleteNum(data.completeNum);
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };
    const getQuestList = () => {
        let url = new URL(basic.server + v_member.member + v_member.quest_list);
        let params = {};
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code === Values.SUCCESS_CODE) {
                    setQuest(data.questList);
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        getCompleteNum();
    }, []);
    useEffect(() => {
        getQuestList();
    }, []);

    return (
        <div className="contentSmallPdTop">
            {member.classVersion === 4 ? (
                <TitleBackBar
                    history={history}
                    title="재료판매 임무 목록"
                    titleIcon="order"
                />
            ) : (
                <TitleBackBar
                    history={history}
                    title="분해임무 목록"
                    titleIcon="order"
                />
            )}

            <Box display="grid" justifyContent="center" alignItems="center">
                <List className={classes.list}>
                    {quest.map((item: any, index) => {
                        return (
                            <ListItem
                                className={
                                    item.require_num > completeNum
                                        ? classes.questItem
                                        : classes.questItemComplete
                                }
                                alignItems="center"
                            >
                                <QuestItem
                                    {...item}
                                    completeNum={completeNum}
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </Box>
        </div>
    );
};

const QuestItem: React.FC<any> = (props) => {
    const classes = useStyles();

    return (
        // new version
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={7} style={{ margin: 'auto', paddingLeft: '1vw' }}>
                <Grid container direction="column">
                    <Grid id="QuestMoney">
                        <Typography
                            display="inline"
                            variant="h3"
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                                fontWeight: 'bold',
                            }}
                        >
                            {/* {props.materialCount > 1 ? `${props.materialName} 외 ` : `${props.materialName} `} */}
                            {`${props.quest_money} 원`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={3} style={{ margin: 'auto', textAlign: 'right' }}>
                <Typography className={classes.sideText}>
                    {props.require_num <= props.completeNum && `임무 완료`}
                    {props.require_num > props.completeNum &&
                        `${props.completeNum} / ${props.require_num}`}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default QuestList;
